import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "#232426",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M37.704 17.204V40H3.296V17.204zM20.07 25.806a3.871 3.871 0 1 0 0 7.742 3.871 3.871 0 0 0 0-7.742zM20.5 0c9.502 0 17.204 7.703 17.204 17.204h-5.161c0-6.65-5.392-12.043-12.043-12.043S8.457 10.553 8.457 17.204H3.296C3.296 7.703 10.998 0 20.5 0z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }